module.exports = __webpack_public_path__ + "img/forum-events-512-maskable.8f76effd.png";